import { Typography, Box, Stack, Button } from '@mui/material'
import { PageHeader } from '@/components'
import { COMMERCIAL_PHONE } from '@/constants/phones'

export function ReferAndEarnPage() {
  return (
    <>
      <PageHeader>Indique e Ganhe</PageHeader>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 6,
            paddingTop: 4,
            maxWidth: 460,
          }}
        >
          <Stack sx={{ textAlign: 'left' }}>
            <Typography variant="h3" sx={{ fontWeight: 300, lineHeight: 1.3 }}>
              Indique a Alume Contabilidade: <br /> É simples, rápido, e{' '}
              <span style={{ fontWeight: 600, whiteSpace: 'nowrap' }}>
                todo mundo ganha
              </span>
            </Typography>
          </Stack>

          <Stack sx={{ textAlign: 'left', gap: 3 }}>
            <Typography variant="body1">
              Muito obrigado pela confiança!
            </Typography>
            <Typography variant="body1">
              Ao indicar a Alume para amigos e colegas, você e os indicados que
              iniciarem a contabilidade com a gente ganham{' '}
              <span style={{ fontWeight: 600 }}>desconto de R$100,00 na fatura seguinte</span>{' '}
              seguinte!
            </Typography>

            <Typography variant="body1">
              Ah, e{' '}
              <span style={{ fontWeight: 600 }}>
                não há limite de indicação
              </span>
              . Ou seja, dá para até mesmo{' '}
              <span style={{ fontWeight: 600 }}>zerar{' '}</span>
              sua mensalidade 😉
            </Typography>
          </Stack>

          <Stack sx={{ width: '100%' }}>
            <Button
              component="a"
              href={`https://api.whatsapp.com/send?phone=${COMMERCIAL_PHONE}&text=Olá, gostaria de indicar uma pessoa para a Alume Contabilidade e ganhar um benefício especial.`}
              target="_blank"
              rel="noopener noreferrer"
              variant="contained"
              size="large"
              fullWidth
            >
              Indicar
            </Button>
          </Stack>
        </Box>
      </Box>
    </>
  )
}
